import styled from 'styled-components';
import { colors } from '../../../../../theme/colors';

export const Note = styled.p`
  font-style: italic;
  color: ${colors.GRAY_4};
`;
